import styled from 'styled-components'

interface LegendEntry {
  value: string
  color: string
  isActive: boolean
}
interface CustomLegendProps {
  payload: LegendEntry[]
  onClick: (filterName: string) => void
  disabled?: boolean
}

const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  gap: 24px;
  color: ${p => p.theme.colors.text.primary};
  font-size: 18px;
  font-weight: 600;
  ${p => p.disabled && `opacity: 0.5; pointer-events: none;`}
`

const LegendItem = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;
  ${p => p.disabled && `pointer-events: none;`}
`

const FilterMark = styled.span<{ isActive: boolean; color: string }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${p => (p.isActive ? p.color : 'transparent')};
  border: ${p => (p.isActive ? '' : `1px solid ${p.theme.colors.text.primary}`)};
  margin-right: 8px;
`

const checkIsClickDisabled = (entryKey: string, payload: LegendEntry[]) =>
  !payload.find(entry => entry.value !== entryKey)?.isActive

export const CustomLegend = ({ payload, onClick, disabled }: CustomLegendProps) => (
  <Container disabled={disabled}>
    {payload.map(entry => (
      <LegendItem
        key={entry.value}
        onClick={() => onClick(entry.value)}
        disabled={checkIsClickDisabled(entry.value, payload)}
      >
        <FilterMark isActive={entry.isActive} color={entry.color} />
        {entry.value}
      </LegendItem>
    ))}
  </Container>
)
